$(document).ready(function() {

  $(".js-slider-text").each(function() {
    const $slider = $(this);
    $slider.slick({
      slidesToShow: 1, infinite: true, arrows: true,
      prevArrow: $slider.parents(".image-text-content").find(".slider-button--prev"),
      nextArrow: $slider.parents(".image-text-content").find(".slider-button--next"),
      responsive: [
  { breakpoint: 1024, settings: { slidesToShow: 1, infinite: true } },
  { breakpoint: 600, settings: { slidesToShow: 1, infinite: false, dots: false, arrows: true } }
]
    });
  });

  $(".js-testimonial").each(function() {
    const $slider = $(this);
    $slider.slick({
      slidesToShow: 1, infinite: false, arrows: true,
      prevArrow: $slider.parents(".testimonial").find(".slider-button--prev"),
      nextArrow: $slider.parents(".testimonial").find(".slider-button--next"),
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 1, infinite: true } },
        { breakpoint: 600, settings: { slidesToShow: 1, dots: false, arrows: true } }
      ]
    });
  });

  $(".js-video-list").each(function() {
    const $slider = $(this);
    $slider.on('init', function() {
      $(this).css('visibility', 'visible');
    }).slick({
      slidesToShow: $slider.data('desk-col'),
      infinite: false, arrows: true,
      prevArrow: $slider.parents(".video-list-container").find(".slider-button--prev"),
      nextArrow: $slider.parents(".video-list-container").find(".slider-button--next"),
      responsive: [
{ breakpoint: 1024, settings: { slidesToShow: $slider.data('desk-col'), infinite: false } },
{ breakpoint: 600, settings: { slidesToShow: $slider.data('mobile-col'), infinite: false, dots: false, arrows: true } }
      ]
    });
    setTimeout(function() { $slider.css('visibility', 'visible'); }, 2000);
  });

  $(document).on("click", ".video--play-btn, .block__homereview-video-boxplay", function() {
    var current_video = $(this).closest(".video-with-text-container").find("video")[0];
    if (!current_video) return;
    if (current_video.paused) {
      $(current_video).attr("controls", "true").prop("muted", false);
      current_video.play();
      $(this).closest(".video-with-text-container").find('.video-start').addClass('hidden');
      $(this).closest(".video-with-text-container").find('.video-stop').removeClass('hidden');
    } else {
      current_video.pause();
      $(this).closest(".video-with-text-container").find('.video-start').removeClass('hidden');
      $(this).closest(".video-with-text-container").find('.video-stop').addClass('hidden');
    }
  });

    // Init WOW immediately without waiting
   if (typeof WOW !== 'undefined') {
  new WOW({
    offset: 50,
    mobile: true,
    live: false,
    callback: function(box) {
      box.classList.add('animated');
    }
  }).init();
} else {
  setTimeout(function() {
    if (typeof WOW !== 'undefined') {
      new WOW({ offset: 50, mobile: true, live: false }).init();
    }
  }, 500);
}

});